import { EditableEntity, ICreatableEntityCollection,
  IEditableEntity, IPropEventBroker,
  IReadablePropEventBroker } from '@zdrbm/zdr-native-tools';
import { ISuggestion } from './Suggestion';

export interface IAutocompleteSuggestions extends IEditableEntity {
  query: IReadablePropEventBroker<string>;
  /**
   * This is a way for the servert to remember the context of the user's query for subsequent requests.
   */
  session: IReadablePropEventBroker<string | undefined>;
  items: ICreatableEntityCollection<ISuggestion>;
  clearSession(): void;
}

export class AutocompleteSuggestions extends EditableEntity<keyof IAutocompleteSuggestions> implements IAutocompleteSuggestions {
  items: ICreatableEntityCollection<ISuggestion>;
  query: IReadablePropEventBroker<string>;
  session: IPropEventBroker<string | undefined>;

  constructor(query: string, items: ISuggestion[], session: string) {
    super(undefined);

    this.query = this.createPropEventBroker<string>('query', query);
    this.items = this.createEntityCollection<ISuggestion>('suggestions', items);
    this.session = this.createPropEventBroker<string>('session', session);
  }

  clearSession(): void {
    this.session.set(undefined);
  }

  getEntityName(): string {
    return 'AutocompleteSuggestions';
  }
}